const appbar = {
  title: "Login",
  color: "#1A237E",
  Home: { title: "Home", color: "#2196F3" },
  Login: { title: "Login", color: "#1A237E" },
  Programs: { title: "Programs", color: "#673AB7" },
  Funding: { title: "Funding", color: "#009688" },
  TechSupport: { title: "Tech Support", color: "#424242" },
  Graphics: { title: "Graphics", color: "#2196F3" },
  Administrator: { title: "Administrator", color: "#607D8B" },
  GenericUploader: { title: "Document Uploader", color: "#424242" },
};

export default appbar;



// WEBPACK FOOTER //
// ./app/data/appbar.js